import { render, staticRenderFns } from "./Stockpurchaseedit.vue?vue&type=template&id=bdf7ec68&scoped=true&"
import script from "./Stockpurchaseedit.vue?vue&type=script&lang=js&"
export * from "./Stockpurchaseedit.vue?vue&type=script&lang=js&"
import style0 from "./Stockpurchaseedit.vue?vue&type=style&index=0&id=bdf7ec68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf7ec68",
  null
  
)

export default component.exports